<template>
  <ol class="jbh-overview">
    <li>
      <router-link to="/jbh/complaintManage">投诉管理</router-link>
    </li>
    <li>
      <router-link to="/jbh/tagScore">标记评分</router-link>
    </li>
    <li>
      <router-link to="/jbh/accountSafetyLevelSetting">账户安全限制</router-link>
    </li>
    <li>
      <router-link to="/jbh/accountAppeal">账号申诉</router-link>
    </li>
  </ol>
</template>

<script setup></script>

<style lang="scss" scoped>
  .jbh-overview {
    margin: 15vh 20vw 0;

    li {
      margin-bottom: 8px;
      font-size: 16px;
      line-height: 1.25;
    }
  }
</style>
